import { getCoreRowModel, getSortedRowModel, SortingState, useReactTable } from '@tanstack/react-table'
import React, { useState } from 'react'
import TanStackTable from '../../../../../components/tables/TanStackTable'
import purchaseReportTableData from './purchaseReportTableData'
import { useNavigate } from 'react-router-dom'
import { useUserContext } from '../../../../../context/UserProvider'
import { columnSum, formatCurrency } from '../../../../../utils/tableFuncs'

type PurchaseReportTableProps = {
  data: any
  isLoading?: boolean
}
function PurchaseReportTable({ data, isLoading }: PurchaseReportTableProps) {
  let navigate = useNavigate()
  const [sorting, setSorting] = useState<SortingState>([])

  // @ts-ignore  remove this ts-ignore when UserContext is type safe
  const { handleSetConsolidateInvoice, chosenCompany } = useUserContext()
  const columns = purchaseReportTableData(chosenCompany)

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  const footerData = {
    amountIncVAT: isNaN(columnSum(data, 'amountIncVAT'))
      ? formatCurrency(0)
      : formatCurrency(columnSum(data, 'amountIncVAT')),
  }

  return (
    <TanStackTable
      table={table}
      handleRowClick={(e) => {
        handleSetConsolidateInvoice(e.original.consolidatedInvoiceAgreement)
        navigate(`/reports/purchase/${e.original.tyear}/${e.original.tmonth}`)
      }}
      isLoading={isLoading}
      footerData={footerData}
    />
  )
}

export default PurchaseReportTable
